import React from 'react'
import { GetAlertsBtn } from '../../Components/Buttons/GetAlertsBtn'
import { Box, PageContainerMain } from '../../Components/Layout'
import { Con } from '../../Components/Layout/Containers/ConStyles'
import { Head } from '../../Components/Typography/Text.styles'
import { FreeAgencyTabs } from './FreeAgencyTabs'
import { AdUnit } from '../../Components/Ads/AdUnit'

const FreeAgency: React.FC<React.PropsWithChildren<unknown>> = () => {

  return (
    <>
      <PageContainerMain>
        <Box noMargin>
          <AdUnit bannerType="bannerMain" aria-label="Player Movement page ad header" />
          <Con direction="row" justify="space-between" align="center">
            <Head>Player Movement Tracker</Head>
            <GetAlertsBtn btnStyle="outlined" location={'Player Movement Page'}>
              Get Alerts
            </GetAlertsBtn>
          </Con>
          <FreeAgencyTabs />
          <AdUnit bannerType="bannerSecond" aria-label="Player Movement page ad footer" />
        </Box>
      </PageContainerMain>
    </>
  )
}

export default FreeAgency
